// Cross-origin links are absolute in prod and relative in dev/tests, where the origin vars are empty.
const APP_ORIGIN = ((import.meta.env.VITE_APP_ORIGIN as string | undefined) ?? '').replace(/\/$/, '')
const MARKETING_ORIGIN = ((import.meta.env.VITE_MARKETING_ORIGIN as string | undefined) ?? '').replace(/\/$/, '')

export const appHref = (path: string): string => `${APP_ORIGIN}${path}`

export const marketingHref = (path: string): string => `${MARKETING_ORIGIN}${path}`
